import { useEffect, useRef } from 'react';
import { Chart, ChartData, ChartOptions, registerables } from 'chart.js';

// Register all necessary Chart.js components (including CategoryScale)
Chart.register(...registerables);

interface InvestmentGraphProps {
    data: ChartData;
}

export default function InvestmentGraph({ data }: InvestmentGraphProps) {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const chartInstance = useRef<Chart | null>(null);

    useEffect(() => {
        if (!canvasRef.current) return;

        // Destroy previous chart
        if (chartInstance.current) {
            chartInstance.current.destroy();
        }

        // Create new chart
        chartInstance.current = new Chart(canvasRef.current, {
            type: 'line',
            data,
            options: {
                responsive: true,
                scales: {
                    x: {
                        type: 'category',
                        title: { display: true, text: 'Periode' }
                    },
                    y: {
                        type: 'linear',
                        title: { display: true, text: 'Værdi' }
                    }
                }
            } as ChartOptions
        });

        return () => {
            chartInstance.current?.destroy();
        };
    }, [data]);

    return <canvas ref={canvasRef} />;
}
